import { Stack } from 'expo-router';
import { useTheme } from 'smoothie';

import { useUserAuthorization } from '../../../auth/hooks/useUserAuthorization';
import { LimitedAccessScope } from '../../../auth/types/UserAuthorization';
import { LimitedAccessPageHeader } from '../../../common/components/LimitedAccessPageHeader';

export default function BankingLayout() {
    const { limitedAccessScope } = useUserAuthorization();

    const limitedAccessHeaderShown =
        limitedAccessScope === LimitedAccessScope.BANKING ||
        limitedAccessScope === LimitedAccessScope.KYC;

    const theme = useTheme();

    return (
        <Stack
            screenOptions={{
                headerShown: limitedAccessHeaderShown,
                header: () => {
                    return (
                        limitedAccessHeaderShown && (
                            <LimitedAccessPageHeader headerTitle="Banking" />
                        )
                    );
                },
                contentStyle: {
                    backgroundColor: theme.background.get(),
                },
            }}
        />
    );
}
